"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloudError = /** @class */ (function () {
    function CloudError(data) {
        Object.assign(this, data);
    }
    return CloudError;
}());
exports.CloudError = CloudError;
//# sourceMappingURL=cloud-error.js.map